import React from 'react';


export default class DateField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      changed: false
    };
    this.intervalId = 0;
  }
  componentWillUnmount(){
    if(this.state.changed)
      this.up();
  }
  componentDidUpdate(prevProp, prevState){
    if((prevProp.refs !== this.props.refs)){
      if(this.state.changed)
        this.up();
      this.setState({
        changed: false
      })
    }
    if(prevProp.value !== this.props.value){
      this.setState({
        value: this.props.value,
        changed: true,
      }, () => { this.up()  })
    }
  }

  handleChange = (e) => {
    const re = /^[0-9\b]+$/;
    var val = e.target.value;
    // console.log('value: '+val)
    if (val !== '') {
      this.setState({
        value: val,
        changed: true
      }, ()=>{
        this.up();
      })
      e.preventDefault();
    }
  }

  handleFocus(event) {
    event.target.select();
  }

  up = () =>{
    if((this.state.changed)&&(this.props.callback !== null)){
      // console.log("date cb called!")
      this.props.callback({
          field: this.props.name,
          value: this.state.value,
      })
    }
  }
  render() {
    let pr = {...this.props}
    pr.callback = null;
    pr.value = null;
    return (

        <input
          {...pr}
          name={this.props.name}
          type="date"
          min="1900-01-01"
          max="2100-12-31"
          value={this.state.value}
          autoComplete="off"
          onBlur={this.up}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          className={"form-control "+this.props.className}
        />
    );
  }
}
